import { Redirect, useLocation } from 'react-router-dom';
import { HasPermission } from 'react-role-permission';
import { getAppLinkPath, useAppLink } from '../../utils/link.utils';

const AuthGate = ({ children }) => {
  const location = useLocation();
  const link = useAppLink();
  const pathname = getAppLinkPath(location.pathname);

  if (HasPermission(pathname)) {
    return children;
  }

  if (pathname.includes('view')) {
    return children;
  }

  return <Redirect to={link("/portal")} />;
};

export default AuthGate;
